import NavigationPrompt from 'react-router-navigation-prompt';
import { UnsavedChangesModal } from 'components/unsaved-changes-modal';

interface Props {
  hasChanges: boolean;
  message: string;
}

/**
 * Asks before a route change throws away unsaved work. Hash-only navigation is let through.
 *
 * @param {Props} props - Component props.
 * @param {boolean} props.hasChanges - Whether there is unsaved work to guard.
 * @param {string} props.message - What will be lost, shown in the question.
 * @return {JSX.Element} The route prompt, which renders the question only while asking.
 */
const NavigationGuard = ({ hasChanges, message }: Props) => (
  <NavigationPrompt
    when={(_current, next) => {
      return hasChanges && !next?.hash;
    }}
  >
    {({ onConfirm, onCancel }) => (
      <UnsavedChangesModal
        message={message}
        onKeep={onCancel}
        onDiscard={onConfirm}
      />
    )}
  </NavigationPrompt>
);

export { NavigationGuard };
